import { createSlice } from '@reduxjs/toolkit';

/**
 * App state slice
 * Manages global app settings like debug features
 */

// Load debug settings from localStorage on initialization
const getInitialState = () => {
  let debugSettings = {
    enabled: false,
    showPdfPreview: false,
  };

  try {
    const stored = localStorage.getItem('debugSettings');
    if (stored) {
      debugSettings = JSON.parse(stored);
    }
  } catch (error) {
    console.warn('Failed to load debug settings from localStorage:', error);
  }

  return {
    debugFeatures: debugSettings,
  };
};

const appSlice = createSlice({
  name: 'app',
  initialState: getInitialState(),
  reducers: {
    // Toggle debug features on/off
    toggleDebugFeatures: (state) => {
      state.debugFeatures.enabled = !state.debugFeatures.enabled;
      // Persist to localStorage
      saveDebugSettings(state.debugFeatures);
    },

    // Set debug features to specific values
    setDebugFeatures: (state, action) => {
      state.debugFeatures = {
        ...state.debugFeatures,
        ...action.payload,
      };
      // Persist to localStorage
      saveDebugSettings(state.debugFeatures);
    },

    // Load debug settings from localStorage (called on app init)
    loadDebugSettings: (state) => {
      try {
        const stored = localStorage.getItem('debugSettings');
        if (stored) {
          state.debugFeatures = JSON.parse(stored);
        }
      } catch (error) {
        console.warn('Failed to load debug settings:', error);
      }
    },
  },
});

// Helper function to save debug settings to localStorage
const saveDebugSettings = (settings) => {
  try {
    localStorage.setItem('debugSettings', JSON.stringify(settings));
  } catch (error) {
    console.warn('Failed to save debug settings:', error);
  }
};

export const { toggleDebugFeatures, setDebugFeatures, loadDebugSettings } = appSlice.actions;
export default appSlice.reducer;

// Selectors
export const selectDebugFeatures = (state) => state.app.debugFeatures;
export const selectIsDebugEnabled = (state) => state.app.debugFeatures.enabled;

